import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { Size } from '~/statistics/types/profile-card.types'

import ActivitySetProgress from '../CircularProgress'

interface Props {
  setsProgress: number
  setsCompletedCount: number
  totalSetsCount: number
  totalAnswered: number
}

const mediaQuery = [{ screen: '(min-width: 280px)', width: '60vw' }]

export default function ActivitySetsSummary(props: Props): React.ReactElement {
  const { t } = useTranslation('statistics')

  const { setsProgress, setsCompletedCount, totalSetsCount, totalAnswered } = props

  return (
    <div className="w-full font-semibold rounded overflow-hidden shadow-card space-y-3 py-2">
      <p className="text-center">
        <span className="text-purple">{t('activity-sets')}</span> {setsCompletedCount}/{totalSetsCount}
      </p>
      <ActivitySetProgress hideCheckmark percentage={setsProgress} size={Size.LARGE} />
      <div className="flex items-center justify-center">
        <ResponsiveImage
          alt={t('alt_texts.answered')}
          height={40}
          imageClassName="mr-2 h-5"
          mediaQuery={mediaQuery}
          srcKey="scoreboard/activities-done.png"
        />
        <p className="font-medium">{t('answered', { n: totalAnswered })}</p>
      </div>
    </div>
  )
}
